export default class SliderWeeks {
  constructor(el) {
    this.el = el
  }
}
